import { useNavigate, useLocation } from 'react-router-dom';
import { BROWSE_FREELANCERS_ROUTE, CHAT_ROUTE, CREATE_NEW_PROJECT_ROUTE, DASHBOARD_ROUTE, ENGAGEMENTS_ROUTE, FORGOT_PASSWORD_ROUTE, JOBS_ROUTE, LANDING_PAGE_ROUTE, LOGIN_ROUTE, MY_PROJECTS_ROUTE, NOT_FOUND_404_ROUTE, PARTNERS_AND_AFFILIATES_ROUTE, PRICING_ROUTE, PROJECT_DETAILS_ROUTE, PROJECTS_ROUTE, SIGNUP_ROUTE, SIGNUP_UPDATE_PROFILE_ROUTE, UNASSIGNED_TASKS_ROUTE, USER_PROFILE_ROUTE } from '../App';
import { EUserType } from '../data_models/enums';

export enum EProjectDetailsNav {
    OVERVIEW = 'overview',
    ROADMAP = 'roadmap',
    TEAM = 'team',
    ATTACHMENTS = 'attachments',
    CHAT = 'chat',
}

function useRouting() {
    const navigate = useNavigate();
    const location = useLocation();

    const goToLandingPage = () => navigate(LANDING_PAGE_ROUTE);
    const goToSignup = () => navigate(SIGNUP_ROUTE);
    const goToLogin = () => navigate(LOGIN_ROUTE);
    const goToSignupFreelancers = () => navigate(SIGNUP_ROUTE + '?type=freelancer');
    const goToSignupEmployers = () => navigate(SIGNUP_ROUTE + '?type=employer');
    const goToSignupUpdateProfile = () => navigate(SIGNUP_UPDATE_PROFILE_ROUTE);
    const goToLoginFreelancers = () => navigate(LOGIN_ROUTE + '?type=freelancer');
    const goToLoginEmployers = () => navigate(LOGIN_ROUTE + '?type=employer');
    const goToForgotPasswordPage = () => navigate(FORGOT_PASSWORD_ROUTE);
    const goToCreateNewProject = () => navigate(CREATE_NEW_PROJECT_ROUTE);
    const goToUserProfile = (type: EUserType, userId: string) => navigate(`${USER_PROFILE_ROUTE}?type=${type}&id=${userId}`);
    const goToDashboard = () => navigate(DASHBOARD_ROUTE);
    const goToProjects = () => navigate(PROJECTS_ROUTE);
    const goTo404 = () => navigate(NOT_FOUND_404_ROUTE);
    const goToBrowseFreelancers = () => navigate(BROWSE_FREELANCERS_ROUTE);
    const goToMyProjects = () => navigate(MY_PROJECTS_ROUTE);
    const goToProjectDetails = (projectId: string, detailsNav?: EProjectDetailsNav) => navigate(`${PROJECT_DETAILS_ROUTE}?id=${projectId}${detailsNav ? `&nav=${detailsNav}` : ''}`);
    const goToUnassignedTasks = () => navigate(UNASSIGNED_TASKS_ROUTE);
    const goToJobs = () => navigate(JOBS_ROUTE);
    const goToChat = () => navigate(CHAT_ROUTE);
    const goToEngagements = () => navigate(ENGAGEMENTS_ROUTE);
    const goToPartnersAndAffiliates = () => navigate(PARTNERS_AND_AFFILIATES_ROUTE);

    const goToPricing = () => navigate(PRICING_ROUTE);
    const goToExternalLink = (link: string) => window.open(link, '_blank');

    const isCurrentPath = (path: string) => location.pathname === path;

    return {
        goToLandingPage,
        goToSignup,
        goToLogin,
        goToSignupFreelancers,
        goToSignupEmployers,
        goToSignupUpdateProfile,
        goToLoginFreelancers,
        goToLoginEmployers,
        goToForgotPasswordPage,
        goToUserProfile,
        goToCreateNewProject,
        goToDashboard,
        goToProjects,
        isCurrentPath,
        goTo404,
        goToBrowseFreelancers,
        goToMyProjects,
        goToProjectDetails,
        goToUnassignedTasks,
        goToJobs,
        goToChat,
        goToEngagements,
        goToPartnersAndAffiliates,
        goToPricing,
        goToExternalLink
    };
}

export default useRouting;